const oauth = {
  domain: 'coinl-member-stg3.auth.us-east-2.amazoncognito.com',
  scope: ['profile', 'email', 'openid', 'aws.cognito.signin.user.admin'],
  //redirectSignIn: 'https://liff.line.me/1657205388-XYJPpBdb/',
  //redirectSignOut: 'https://liff.line.me/1657205388-XYJPpBdb/',
  //redirectSignIn: 'http://localhost:11180/login-progress',
  //redirectSignOut: 'http://localhost:11180/login',
  redirectSignIn: 'https://stg-member-laundrymanagement.kujira-realestatetech.co.jp/login-progress',
  redirectSignOut: 'https://stg-member-laundrymanagement.kujira-realestatetech.co.jp/login',
  responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
}

export default oauth